"use client";

import * as React from "react";
import Image from "next/image";
import Autoplay from "embla-carousel-autoplay";
import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from "@/components/ui/carousel";
import { cn } from "@/lib/utils";

const MOCK_GALLERY_IMAGES = [
  "https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?q=80&w=2906&auto=format&fit=crop",
  "https://images.unsplash.com/photo-1600585154340-be6161a56a0c?q=80&w=2940&auto=format&fit=crop",
  "https://images.unsplash.com/photo-1512453979798-5ea904ac848e?q=80&w=2940&auto=format&fit=crop",
  "https://images.unsplash.com/photo-1600566753190-17f0baa2a6c3?q=80&w=2940&auto=format&fit=crop",
  "https://images.unsplash.com/photo-1600585154526-990dced4db0d?q=80&w=2940&auto=format&fit=crop",
];

interface PropertyGalleryProps {
  images?: string[];
  className?: string;
}

export function PropertyGallery({ images = MOCK_GALLERY_IMAGES, className }: PropertyGalleryProps) {
  // Use provided images if available and not empty, otherwise fallback to mock
  const displayImages = images && images.length > 0 ? images : MOCK_GALLERY_IMAGES;

  return (
    <section className={cn("py-24 bg-secondary/5", className)}>
      <div className="max-w-[1400px] mx-auto px-6 md:px-12">
        <div className="text-center mb-16 space-y-4">
          <div className="space-y-4">
            <span className="text-xs font-bold tracking-[0.3em] text-secondary uppercase block">
              Glimpse into your future home
            </span>
            <h2 className="font-serif text-3xl md:text-5xl text-primary">
              Gallery
            </h2>
          </div>
        </div>

        <Carousel
          plugins={[
            Autoplay({
              delay: 4000,
            }),
          ]}
          opts={{
            align: "start",
            loop: true,
          }}
          className="w-full"
        >
          <CarouselContent className="-ml-4">
            {displayImages.map((image, index) => (
              <CarouselItem key={index} className="pl-4 md:basis-1/2 lg:basis-2/3">
                <div className="relative aspect-[16/10] overflow-hidden rounded-xl bg-muted shadow-2xl hover:shadow-[0_25px_50px_-12px_rgba(0,0,0,0.25)] transition-all duration-300">
                  <Image
                    src={image}
                    alt={`Property Gallery Image ${index + 1}`}
                    fill
                    className="object-cover hover:scale-105 transition-transform duration-700"
                    sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 66vw"
                  />
                </div>
              </CarouselItem>
            ))}
          </CarouselContent>
          <div className="flex justify-center gap-4 mt-8 relative static-buttons">
            <CarouselPrevious className="static translate-y-0 translate-x-0 h-12 w-12 border-primary/20 hover:bg-primary hover:text-white" />
            <CarouselNext className="static translate-y-0 translate-x-0 h-12 w-12 border-primary/20 hover:bg-primary hover:text-white" />
          </div>
        </Carousel>
      </div>
    </section>
  );
}
